import { render } from "./SidenavCard.vue?vue&type=template&id=2e125302"
import script from "./SidenavCard.vue?vue&type=script&lang=js"
export * from "./SidenavCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__